module.exports = __webpack_public_path__ + "img/trial4-3.c7cb95fc.png";